import _ from 'lodash';

const fontnames = [
    'ALAEM', 'Arial', 'Tahoma', 'Times New Roman', 'cambria', 'IRANSans', 'Dast Nevis',
    'B Arab Style', 'B Arash', 'B Aria', 'B Arshia', 'B Aseman', 'B Badkonak',
    'B Badr', 'B Baran', 'B Bardiya', 'B Cheshmeh', 'B Chini', 'B Compset',
    'B Davat', 'B Elham', 'B Elm', 'B Esfahan', 'B Fantezy', 'B Fardosi',
    'B Farnaz', 'B Haleh', 'B Hamid', 'B Helal', 'B Homa', 'B Jadid',
    'B Jalal', 'B Kaj', 'B Kamran', 'B Karim', 'B Kaveh', 'B Kidnap',
    'B Koodak', 'B Kourosh', 'B Lotus', 'B Mah', 'B Mahsa', 'B Majid shadow',
    'B Mashhad', 'B Masjed', 'B Medad', 'B Mehr', 'B Mitra', 'B Moj',
    'B Morvarid', 'B Narenj', 'B Narm', 'B Nasim', 'B Nazanin',
    'B Nazanin-Arabi', 'B Nazi', 'B Niki', 'B Nikoo', 'B Paatch', 'B Rose',
    'B Roya', 'B Sahar', 'B Sahra', 'B Sara', 'B Sepideh', 'B Setareh',
    'B Shadi', 'B Shiraz', 'B Siavash', 'B Sina', 'B Sooreh', 'B Sorkhpust',
    'B Tabassom', 'B Tanab', 'B Tafwig Outline', 'B Tehran', 'B Tir', 'B Titr',
    'B Traffic', 'B Vahid', 'B Vosta', 'B Yagut', 'B Yekan', 'B Zaman', 'B Zar',
    'B Ziba',
];

export default {
    inline: true,
    directionality : 'rtl',
    branding: false,
    plugins: [
        'position advlist autolink autoresize charmap code contextmenu',
        'directionality effects emoticons formula_picker hr image imagetools',
        'insertdatetime lineheight line link lists media noneditable paste',
        'print searchreplace store_item styles table tcolorpicker textcolor',
        'upload_image visualblocks wordcount',
    ],
    toolbar_items_size: 'small',
    toolbar: [
        'insertfile undo redo | styleselect fontselect fontsizeselect' +
        ' lineheight paragraph_spacing forecolor backcolor',
        'bold italic underline strikethrough border_bottom border superscript subscript |' +
        ' ltr rtl float_left float_right | alignleft aligncenter alignright alignjustify |' +
        ' align_top align_middle align_bottom',
        'bullist numlist outdent indent | upload_image' +
        ' image link | searchreplace | hr charmap emoticons' +
        ' formula_picker | guide',
    ],
    menubar: false,
    themes: 'modern',
    imagetools_cors_hosts: ['mhelli.com', 'mhelli.ir'],
    image_caption: true,
    image_advtab: true,
    fontsize_formats: _.map(
        Array(32),
        (_, index) => index < 5 ? `${index + 6}pt` : index === 5 ? '10.5pt' : `${index + 5}pt`,
    ).join(' '),
    font_formats: _.map(fontnames, name => `${name}= ${name}`).join(';'),
    style_formats_autohide: true,
    force_br_newlines: true,
    force_p_newlines: false,
    autoresize_bottom_margin: 20,
    language: 'fa_IR',
    charmap_append: [
        [10003, '-'],
        [10004, '-'],
        [10005, '-'],
        [10006, '-'],
        [10007, '-'],
        [10008, '-'],
        [10060, '-'],
    ],
    content_css: window.hashed_paths['css/tinymce.css'] + ',' + window.hashed_paths['css/mathjax.css'],
    table_default_attributes: {
        cellspacing: '0',
        cellpadding: '0',
        border: '1',
    },
    setup : editor => {
        editor.on('init', () => {
            const formats = editor.formatter.get();
            formats.fontsize.push(_.cloneDeep(formats.fontsize[0]));
            formats.fontsize[1].ceFalseOverride = true;
            formats.fontsize[1].selector = 'span';
            formats.fontsize[1].split = true;
            formats.fontsize[1].remove = 'fontsize';
            formats.fontsize[1].defaultBlock = 'span';

            formats.fontname.push(_.cloneDeep(formats.fontname[0]));
            formats.fontname[1].ceFalseOverride = true;
            formats.fontname[1].selector = 'span';
            formats.fontname[1].split = true;
            formats.fontname[1].remove = 'fontsize';
            formats.fontname[1].defaultBlock = 'span';

            formats.forecolor.push(_.cloneDeep(formats.forecolor[0]));
            formats.forecolor[1].ceFalseOverride = true;
            formats.forecolor[1].selector = 'span';
            formats.forecolor[1].split = true;
            formats.forecolor[1].remove = 'fontsize';
            formats.forecolor[1].defaultBlock = 'span';

            formats.hilitecolor.push(_.cloneDeep(formats.hilitecolor[0]));
            formats.hilitecolor[1].ceFalseOverride = true;
            formats.hilitecolor[1].selector = 'span';
            formats.hilitecolor[1].split = true;
            formats.hilitecolor[1].remove = 'fontsize';
            formats.hilitecolor[1].defaultBlock = 'span';

            editor.getBody().style.fontSize = '11pt';
            editor.getBody().style.fontFamily = 'IRANSans';
            editor.getBody().style.lineHeight = 'initial';
            editor.getBody().style.lineHeight = 'initial';
        });
        function fixEmptyNodes(elements) {
            _.forEach(elements, element => {
                if (element.innerHTML.trim() === '<br>')
                    element.innerHTML = '';
            });
        }
        editor.on('keyup', () => {
            const body = editor.getBody();
            fixEmptyNodes(body.querySelectorAll('.options-container>.option'));
            fixEmptyNodes(body.querySelectorAll('.question>.description'));
            fixEmptyNodes(body.querySelectorAll('.poem>.verse'));
        });
        editor.on('keydown', event => {
            const numbar = (() => {
                if (/_mhelli_tinymce_numbar=1/.test(window.top.document.cookie))
                    return 1;
                else if (/_mhelli_tinymce_numbar=2/.test(window.top.document.cookie))
                    return 2;
                else
                    return 2;
            })();
            const numpad = (() => {
                if (/_mhelli_tinymce_numpad=1/.test(window.top.document.cookie))
                    return 1;
                else if (/_mhelli_tinymce_numpad=2/.test(window.top.document.cookie))
                    return 2;
                else
                    return 1;
            })();

            const keyCode = (event.keyCode || event.charCode);
            let content = '';
            if (keyCode >= 48 && keyCode <= 57 && !event.shiftKey && !event.altKey) {
                if (event.ctrlKey ^ (numbar === 1))
                    content = (keyCode - 48).persian();
                else
                    content = String(keyCode - 48);
            }
            if (keyCode === 190 && !event.shiftKey && !event.altKey) {
                if (event.ctrlKey ^ (numbar === 1))
                    content = '٫';
                else
                    content = '.';
            }

            if (keyCode >= 96 && keyCode <= 105 && !event.shiftKey && !event.altKey) {
                if (event.ctrlKey ^ (numpad === 1))
                    content = (keyCode - 96).persian();
                else
                    content = String(keyCode - 96);
            }
            if (keyCode === 110 && !event.shiftKey && !event.altKey) {
                if (event.ctrlKey ^ (numpad === 1))
                    content = '٫';
                else
                    content = '.';
            }
            if (keyCode === 71 && event.altKey)
                content = 'ٔ';

            if (content) {
                editor.selection.setContent(content);
                event.preventDefault();
            }
        });
    },
    paste_postprocess: (plugin, args) => {
        _.forEach(
            args.node.classList.contains('formula') ? [args.node] : args.node.querySelectorAll('.formula'),
            formulaElement => {
                formulaElement.innerHTML = '`' + formulaElement.dataset.code + '`';
                formulaElement.classList.remove('mceNonEditable');
                formulaElement.removeAttribute('contenteditable');
            },
        );
    },
};
